module.exports = __webpack_public_path__ + "static/media/secondScreen@3x.f5ed6a58.png";